
export { defaultApiBasicX } from "/__w/wiggot-web/wiggot-web/packages/apis/new-apis/default-api.ts"